export function setShopifyImgWidth(src: string, width: 30 | 50 | 100 | 200 | 300 | 500 | 1000) {
  if (!src) {
    return null;
  }
  const srcSplit = src.split('.');
  const filePath = srcSplit[srcSplit.length - 2];
  srcSplit[srcSplit.length - 2] = `${filePath}_${width}x`;
  return srcSplit.join('.');
}
